export default function Container({ children }) {
  return <div className="container mx-auto px-2 sm:px-1">{children}</div>
}
